import * as R from 'ramda';
import { appUserDS } from './app_user';
import { appUserProshopDS } from './app_user_proshop';
import { ballDrilledDS } from './ball_drilled';
import { customerProshopDS } from './customer_proshop';
import { customerDS } from './customer';
import { proshopDS } from './proshop';
import { specSheetDS } from './spec_sheet';
import { thumbCutDS } from './thumb_cut';
// import { thumbInfoDS } from './thumb_info';
import { executeSql } from '../database';
import * as Promise from 'bluebird';

const datasourcesPromises = {
  appUserDS,
  appUserProshopDS,
  ballDrilledDS,
  customerProshopDS,
  customerDS,
  proshopDS,
  specSheetDS,
  thumbCutDS,
  // thumbInfoDS,
};

export let datasources = {};

export const initDatasources = (databaseAlias, currentUserId, actions) =>
  new Promise(success => {
    const dsPromises = R.pipe(
      R.map(dsPromise => dsPromise(databaseAlias, currentUserId, actions)()),
      R.values
    )(datasourcesPromises);

    const createSynchroTable = () =>
      console.log('creating synchro table') ||
      executeSql(databaseAlias)({
        sql: 'CREATE TABLE IF NOT EXISTS synchro (id, timestamp, username, type, table_name, proshop_id)',
      });

    Promise.all(dsPromises)
      .then(dsPromisesResult => {
        console.log('datasources initialized');
        datasources = R.zipObj(R.keys(datasourcesPromises), dsPromisesResult);
        createSynchroTable().then(() => console.log('synchro table created') || success());
      })
      .catch(error => console.log('initDatasources ERROR!!!', error) || success());
  });
